window.Blimp = window.Blimp || {};

class GroupsView extends Backbone.View {
  initialize() {
    this.reportWasAdded = this.reportWasAdded.bind(this);
    this.group_views = [];
    this.listenTo(Blimp.reports, 'remove', this.reportWasRemoved);
    this.listenTo(Blimp.reports, 'add', this.reportWasAdded);
    Blimp.reports.each(this.reportWasAdded);
  }

  groupViewWasRemoved(view) {
    this.group_views = _.without(this.group_views, view);
  }

  reportWasRemoved(model) {
    const view = _.find(this.group_views, (v) => v.date.isSame(model.date().startOf('day')));
    if (view) {
      view.collection.remove(model);
    }
  }

  reportWasAdded(model) {
    // Groups exists, just add model to group's own collection
    let view = _.find(this.group_views, (v) => v.date.isSame(model.date().startOf('day')));
    if (view) {
      view.collection.add(model);
    } else {
      // Group does not exist; create and render group
      view = new Blimp.GroupView({ date: model.date().startOf('day'), collection: new Backbone.Collection() });
      this.listenToOnce(view, 'remove', this.groupViewWasRemoved);
      this.group_views.push(view);
      this.group_views = _.sortBy(this.group_views, (v) => v.date);
      const index = _.indexOf(this.group_views, view);
      if (index > 0) {
        this.group_views[index - 1].$el.before(view.render().el);
      } else {
        this.$el.append(view.render().el);
      }
      view.collection.add(model);
    }
  }
}

GroupsView.prototype.el = '.groups'

Blimp.GroupsView = GroupsView;
